import { Routes, RouterModule, PreloadAllModules } from '@angular/router'
import { NgModule } from '@angular/core'

import { AuthenticatedAppComponent } from './authenticated-app/authenticated-app.component'
import { AtlasAccessGuard } from './shared/'
import { NoSyllabusComponent } from './shared/'
import { AUTHENTICATED_APP_ROUTES } from './authenticated-app/authenticated-app.routes'
import { MenuItemResolver } from './menu-item.resolver'
import { AppStateResolver } from './app-state.resolver'

const APP_ROUTES: Routes = [
  {
    path: '',
    component: AuthenticatedAppComponent,
    children: AUTHENTICATED_APP_ROUTES,
    canActivate: [AtlasAccessGuard],
    resolve: {
      menuItems: MenuItemResolver,
      appState: AppStateResolver
    }
  },
  {
    path: 'unauthorized',
    component: NoSyllabusComponent
  }
]

@NgModule({
  imports: [
    RouterModule.forRoot(APP_ROUTES, {
      useHash: Boolean(history.pushState) === false,
      preloadingStrategy: PreloadAllModules
    })
  ],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts